// extracted by mini-css-extract-plugin
export var container = "form-container-w-image-module--container--5b347";
export var controlMargin = "form-container-w-image-module--controlMargin--7b6d3";
export var formContainer = "form-container-w-image-module--formContainer--6c952";
export var headline = "form-container-w-image-module--headline--0e1dd";
export var imageContainer = "form-container-w-image-module--imageContainer--dae5a";
export var imageDown = "form-container-w-image-module--imageDown--b9d9d";
export var imageRight = "form-container-w-image-module--imageRight--bd369";
export var tallyForm = "form-container-w-image-module--tallyForm--fce0a";